// 资料下载专区 - 固定 5 项
// 有真实 PDF 后，将对应 url 填成下载地址（支持 http(s) 绝对地址，或 /profile/ 相对路径）即可
export const DOWNLOAD_RESOURCES = [
  { name: '竞赛规则', url: '' },
  { name: '跳绳等级考核标准', url: '' },
  { name: '报名表', url: '' },
  { name: '申报模板', url: '' },
  { name: '训练大纲', url: '' }
]
